const API_BASE = process.env.REACT_APP_API_URL || '';

export async function getReportRuns(orgId, filters = {}) {
  const params = new URLSearchParams();
  if (filters.profileId) params.append('profileId', filters.profileId);
  if (filters.status) params.append('status', filters.status);
  if (filters.periodStart) params.append('periodStart', filters.periodStart);
  if (filters.periodEnd) params.append('periodEnd', filters.periodEnd);
  
  const queryString = params.toString();
  const url = `${API_BASE}/orgs/${orgId}/report-runs${queryString ? '?' + queryString : ''}`;
  
  const response = await fetch(url, {
    credentials: 'include',
    headers: {
      'x-org-id': orgId
    }
  });
  
  if (!response.ok) {
    throw new Error('Failed to fetch report runs');
  }
  
  const data = await response.json();
  return data.runs;
}

export async function getReportRun(orgId, runId) {
  const response = await fetch(`${API_BASE}/orgs/${orgId}/report-runs/${runId}`, {
    credentials: 'include',
    headers: {
      'x-org-id': orgId
    }
  });
  
  if (!response.ok) {
    if (response.status === 404) {
      throw new Error('Report run not found');
    }
    throw new Error('Failed to fetch report run');
  }
  
  const data = await response.json();
  return data.run;
}

export async function createReportRun(orgId, data) {
  const response = await fetch(`${API_BASE}/orgs/${orgId}/report-runs`, {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      'x-org-id': orgId
    },
    body: JSON.stringify(data)
  });
  
  if (!response.ok) {
    throw new Error('Failed to create report run');
  }
  
  const result = await response.json();
  return result.run;
}

export async function getArtifact(orgId, artifactId) {
  const response = await fetch(`${API_BASE}/orgs/${orgId}/artifacts/${artifactId}`, {
    credentials: 'include',
    headers: {
      'x-org-id': orgId
    }
  });
  
  if (!response.ok) {
    throw new Error('Failed to fetch artifact');
  }
  
  const data = await response.json();
  return data.artifact;
}

export async function getArtifactDownload(orgId, artifactId) {
  const response = await fetch(`${API_BASE}/orgs/${orgId}/artifacts/${artifactId}/download`, {
    credentials: 'include',
    headers: {
      'x-org-id': orgId
    }
  });
  
  if (!response.ok) {
    throw new Error('Failed to get download info');
  }
  
  return response.json();
}
